export default __webpack_public_path__ + "static/media/small Purple.b3d2ed07.png";